import { css } from 'styled-components';
import { background as ThemeBG } from '../../styles/colors';
import radius from '../../styles/radius';
import { setMargin, setMarginTop, setMarginRight, setMarginBottom, setMarginLeft, setPadding, setPaddingX, setPaddingY } from '../../utils/setSpacingStyle';
import breakpointStyleProp from '../../utils/breakpointStyleProp';
var justifyContentObj = {
  start: 'flex-start',
  end: 'flex-end',
  between: 'space-between',
  around: 'space-around'
};
export function setJustifyContent(justifyContent) {
  var styleToSet = justifyContentObj[justifyContent] || justifyContent;
  return "justify-content: ".concat(styleToSet, ";");
}
var alignItemsObj = {
  start: 'flex-start',
  end: 'flex-end'
};
export function setAlignItems(alignItems) {
  var styleToSet = alignItemsObj[alignItems] || alignItems;
  return "align-items: ".concat(styleToSet, ";");
}
var alignSelfObj = {
  start: 'flex-start',
  end: 'flex-end'
};
export function setAlignSelf(alignSelf) {
  var styleToSet = alignSelfObj[alignSelf] || alignSelf;
  return "align-self: ".concat(styleToSet, ";");
}
var alignContentObj = {
  start: 'flex-start',
  end: 'flex-end',
  between: 'space-between',
  around: 'space-around'
};
export function setAlignContent(alignContent) {
  var styleToSet = alignContentObj[alignContent] || alignContent;
  return "align-content: ".concat(styleToSet, ";");
}
export function setBorder(style) {
  return "border: ".concat(style, ";");
}
var flexObj = {
  grow: '1 0 auto',
  shrink: '0 1 auto'
};
export function setFlex(flex) {
  var styleToSet = flexObj[flex] || flex;
  return "flex: ".concat(styleToSet, ";");
}
export function setDirection(direction) {
  return "flex-direction: ".concat(direction, ";");
}
export function setWrap(wrap) {
  return "flex-wrap: ".concat(wrap ? 'wrap' : 'nowrap', ";");
}
export function flexParentOptions(_ref) {
  var display = _ref.display;
  if (display === 'flex') {
    return css(["", ";", ";", ";", ";", ";"], breakpointStyleProp('direction', setDirection), breakpointStyleProp('wrap', setWrap), breakpointStyleProp('justifyContent', setJustifyContent), breakpointStyleProp('alignItems', setAlignItems), breakpointStyleProp('alignContent', setAlignContent));
  }
  return '';
}
export function flexChildOptions() {
  return css(["", ";", ";"], breakpointStyleProp('flex', setFlex), breakpointStyleProp('alignSelf', setAlignSelf));
}
export function setPosition(position) {
  return "position: ".concat(position, ";");
}
export function createConstrain(tag) {
  return function setConstrain(hasConstrain) {
    return "".concat(tag, ": ").concat(hasConstrain ? 0 : 'auto', ";");
  };
}
export function setPositionStyles() {
  return css(["", ";", ";", ";", ";", ";"], breakpointStyleProp('bottom', createConstrain('bottom')), breakpointStyleProp('top', createConstrain('top')), breakpointStyleProp('left', createConstrain('left')), breakpointStyleProp('right', createConstrain('right')), breakpointStyleProp('position', setPosition));
}
export function setRadiusConstrain(tag) {
  return function setRadius(hasRadius) {
    return "".concat(tag, ": ").concat(hasRadius || 0, ";");
  };
}
export function setBorderRadiusStyles() {
  return css(["", ";", ";", ";", ";"], breakpointStyleProp('borderTopLeftRadius', setRadiusConstrain('border-top-left-radius')), breakpointStyleProp('borderTopRightRadius', setRadiusConstrain('border-top-right-radius')), breakpointStyleProp('borderBottomLeftRadius', setRadiusConstrain('border-bottom-left-radius')), breakpointStyleProp('borderBottomRightRadius', setRadiusConstrain('border-bottom-right-radius')));
}
export function setBorderStyles() {
  return css(["", ";", ";", ";", ";"], breakpointStyleProp('borderTop', setRadiusConstrain('border-top')), breakpointStyleProp('borderRight', setRadiusConstrain('border-right')), breakpointStyleProp('borderBottom', setRadiusConstrain('border-bottom')), breakpointStyleProp('borderLeft', setRadiusConstrain('border-left')));
}
export function setDisplay(display) {
  switch (display) {
    case 'inlineBlock':
      return "display: inline-block;";
    case 'visuallyHidden':
      return {
        border: "0",
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: "0",
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px"
      };
    default:
      return "display: ".concat(display, ";");
  }
}
export function setSize(key, val) {
  var ext = typeof val === 'number' ? 'px' : '';
  return val ? "".concat(key, ": ").concat(val).concat(ext, ";") : '';
}
export function setOverflow(overflow) {
  switch (overflow) {
    case 'scrollX':
      return "overflow-x: scroll;";
    case 'scrollY':
      return "overflow-y: scroll;";
    default:
      return "overflow: ".concat(overflow, ";");
  }
}
var boxRadius = radius.ra3;
export function setShape(shape) {
  switch (shape) {
    case 'rounded':
      return "border-radius: ".concat(boxRadius, "px;");
    case 'circle':
      return "border-radius: 50%;";
    case 'square':
      return "border-radius: 0;";
    case 'roundedTop':
      return "\n        border-top-right-radius: ".concat(boxRadius, "px;\n        border-top-left-radius: ").concat(boxRadius, "px;\n      ");
    case 'roundedBottom':
      return "\n        border-bottom-right-radius: ".concat(boxRadius, "px;\n        border-bottom-left-radius: ").concat(boxRadius, "px;\n      ");
    case 'roundedLeft':
      return "\n        border-top-left-radius: ".concat(boxRadius, "px;\n        border-bottom-left-radius: ").concat(boxRadius, "px;\n      ");
    case 'roundedRight':
      return "\n        border-top-right-radius: ".concat(boxRadius, "px;\n        border-bottom-right-radius: ").concat(boxRadius, "px;\n      ");
    default:
      return '';
  }
}
export function setColor(color) {
  var styleToSet = ThemeBG[color] || color;
  return "background-color: ".concat(styleToSet, ";");
}

// The css renderd by the component
export default css(["", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], breakpointStyleProp('display', setDisplay), flexParentOptions, flexChildOptions, setPositionStyles, breakpointStyleProp('width', function (width) {
  return setSize('width', width);
}), breakpointStyleProp('minWidth', function (minWidth) {
  return setSize('min-width', minWidth);
}), breakpointStyleProp('maxWidth', function (maxWidth) {
  return setSize('max-width', maxWidth);
}), breakpointStyleProp('height', function (height) {
  return setSize('height', height);
}), breakpointStyleProp('minHeight', function (minHeight) {
  return setSize('min-height', minHeight);
}), breakpointStyleProp('maxHeight', function (maxHeight) {
  return setSize('max-height', maxHeight);
}), breakpointStyleProp('overflow', setOverflow), breakpointStyleProp('shape', setShape), breakpointStyleProp('color', setColor), breakpointStyleProp('border', setBorder), setBorderStyles, setBorderRadiusStyles, setMargin, setMarginTop, setMarginRight, setMarginBottom, setMarginLeft, setPadding, setPaddingX, setPaddingY);